document.addEventListener('DOMContentLoaded', function () {
    const resetPasswordForm = document.querySelector('.reset-password .wrapper > form');

    if (resetPasswordForm) {
        const formInputs = resetPasswordForm.querySelectorAll('input');

        formInputs.forEach(input => {
            if (input.type !== 'hidden') {
                const oldPlaceholder = input.placeholder;
                const label = resetPasswordForm.querySelector(`label[for="${input.id}"]`);

                input.addEventListener('focus', () => {
                    label.classList.add('show');
                    input.placeholder = '';
                })

                input.addEventListener('blur', () => {
                    label.classList.remove('show');
                    input.placeholder = oldPlaceholder;
                })
            }
        });
    }
}, false);
